import { DateFilter } from '../../Shared';
import { ApptTypeFilter } from '../ApptTypeFilter';
import { RescheduledFilter } from '../RescheduledFilter';
import { StatusFilter } from '../StatusFilter';
import { TeamFilter } from '../TeamFilter';

export const FiltersPanel = ({
  isManager,
  isManagerTeamLoading,
  isManagerTeamError,
  filters,
  onChangeFilters,
  managerTeam,
}) => {
  return (
    <>
      {isManager && !isManagerTeamError && (
        <TeamFilter
          callerIds={filters.callerIds}
          onChangeCallerIds={onChangeFilters}
          managerTeam={managerTeam}
          isManagerTeamLoading={isManagerTeamLoading}
        />
      )}
      <DateFilter
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChangeDateRange={onChangeFilters}
      />
      <StatusFilter
        statuses={filters.statuses}
        onChangeStatuses={onChangeFilters}
      />
      <RescheduledFilter
        isRescheduled={filters.isRescheduled}
        toggleIsRescheduled={onChangeFilters}
      />
      <ApptTypeFilter
        apptType={filters.apptType}
        onChangeApptType={onChangeFilters}
      />
    </>
  );
};
